import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  OnChanges,
  DoCheck,
  SimpleChanges,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import {
  IBudgetAllocForm,
  MyPurchaseForm,
} from 'src/app/shared/models/app-models';
import { SelectionModel } from '@angular/cdk/collections';
import { BudgetForm } from '../../add-item-page.component';
import { BudgetCount } from '../item-budget.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { isEqual } from 'lodash';
import { BudgetAllocation } from 'src/app/shared/models/database-models/SaveMyPurchase.model';
import { AddItemService } from '../../add-item.service';
@Component({
  selector: 'app-budget-listing-table',
  templateUrl: './budget-listing-table.component.html',
  styleUrls: ['./budget-listing-table.component.scss'],
})
export class BudgetListingTableComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() isReadOnly: boolean = false;
  @Input() budgetType: string = 'Operating';
  @Output() tableAction = new EventEmitter();
  @Input() budgetList!: BudgetForm;
  @Input() budgetCount!: BudgetCount;
  @Input() isQuantity: boolean = true;
  @ViewChild('MatPaginator') paginator!: MatPaginator;
  currentbudgetList: IBudgetAllocForm[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();
  mode: string = 'Add';
  itemNo?: number;
  isSingleBudget: boolean = true;
  columns = [
    // {
    //   columnDef: 'No',
    //   header: 'No.',
    //   cell: (element: IBudgetAllocForm) => `${element.iBudgetId ?? 0}`,
    // },
    {
      columnDef: 'Percentage',
      header: 'Percentage',
      cell: (element: IBudgetAllocForm) => `${element.Percentage ?? 0}%`,
    },
    {
      columnDef: 'Quantity',
      header: 'Quantity',
      cell: (element: IBudgetAllocForm) => `${element.Quantity ?? 0}`,
    },
    {
      columnDef: 'BudgetType',
      header: 'Budget Type',
      cell: (element: IBudgetAllocForm) => `${element.BudgetType.value ?? ''}`,
    },
    {
      columnDef: 'CostCentre',
      header: 'Cost Centre',
      cell: (element: IBudgetAllocForm) =>
        `${
          element.CostCentre?.value === undefined ||
          element.CostCentre?.value === null
            ? ''
            : element.CostCentre?.value
        }`,
    },
    {
      columnDef: 'GLAcc',
      header: 'G/L Account',
      cell: (element: IBudgetAllocForm) =>
        `${
          element.GLAcc?.value === undefined || element.GLAcc?.value === null
            ? ''
            : element.GLAcc?.value
        }`,
    },
    {
      columnDef: 'OrderNo',
      header: 'Order No.',
      cell: (element: IBudgetAllocForm) =>
        `${
          element.OrderNo?.value === undefined ||
          element.OrderNo?.value === null
            ? ''
            : element.OrderNo?.value
        }`,
    },
    {
      columnDef: 'BudgetExpenditureUsage',
      header: 'Budgeted',
      cell: (element: IBudgetAllocForm) =>
        `${
          element.BudgetExpenditureUsage?.value === undefined ||
          element.BudgetExpenditureUsage?.value === null
            ? ''
            : element.BudgetExpenditureUsage?.value
        }`,
    },
    {
      columnDef: 'BudgetFrequencyUsage',
      header: 'Recurrent',
      cell: (element: IBudgetAllocForm) =>
        `${
          element.BudgetFrequencyUsage?.value === undefined ||
          element.BudgetFrequencyUsage?.value === null
            ? ''
            : element.BudgetFrequencyUsage?.value
        }`,
    },
    {
      columnDef: 'FundCentre',
      header: 'Fund Centre',
      cell: (element: IBudgetAllocForm) =>
        `${
          element.FundCentre?.value === undefined ||
          element.FundCentre?.value === null
            ? ''
            : element.FundCentre?.value
        }`,
    },
    {
      columnDef: 'ProjectBudget',
      header: 'Project Budget',
      cell: (element: IBudgetAllocForm) =>
        `${
          element.ProjectBudget?.value === undefined ||
          element.ProjectBudget?.value === null
            ? ''
            : element.ProjectBudget.value
        }`,
    },
    {
      columnDef: 'ProjectCode',
      header: 'Project Code',
      cell: (element: IBudgetAllocForm) =>
        `${
          element.ProjectCode?.value === undefined ||
          element.ProjectCode?.value === null
            ? ''
            : element.ProjectCode.value
        }`,
    },
  ];
  displayColumns = ['select', ...this.columns.map((c) => c.columnDef)];
  errorMsg: string = "";
  dataSource = new MatTableDataSource<IBudgetAllocForm>([]);
  rowSelection = new SelectionModel<IBudgetAllocForm>(true, []);
  pageSizeOptions = [5, 10, 20, 50];
  pageSize = 5;

  constructor(
    private store: Store<{ form: MyPurchaseForm }>,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogComponent>,
    private addItemService:AddItemService
  ) {
    // set the mode for this component
    this.mode = this.route.snapshot.params['itemNo'] ? 'Edit' : 'Add';
    if (this.mode === 'Edit') {
      this.itemNo = this.route.snapshot.params['itemNo'];
    }
  }

  ngOnInit(): void {
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe((form: MyPurchaseForm) => {
        if (this.mode == 'Edit' && form.ItemList.length !== 0 && this.itemNo) {
          let budgetList = JSON.parse(
            JSON.stringify(
              form.ItemList[this.itemNo - 1].BudgetAllocation.slice()
            )
          );
          this.currentbudgetList = budgetList;
          this.dataSource = new MatTableDataSource<IBudgetAllocForm>(
            this.convertToBudgetTable(budgetList).filter(
              (budget) => !budget.isDeleted
            )
          );
          this.dataSource.paginator = this.paginator;
        }
      });
    this.filterDisplayColumns();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['budgetList']) {
      this.updateTable();
    }
    if(changes['isQuantity']) {
      if(this.isQuantity){
        this.displayColumns = this.columns
        .filter(column => column.columnDef !== 'Percentage')
        .map(c => c.columnDef);
        this.displayColumns = ['select', ...this.displayColumns];
      }else{
        this.displayColumns = this.columns
        .filter(column => column.columnDef !== 'Quantity')
        .map(c => c.columnDef);
        this.displayColumns = ['select', ...this.displayColumns];
      }
      this.filterDisplayColumns()
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  convertToBudgetTable(budgetList: IBudgetAllocForm[]): IBudgetAllocForm[] {
    console.log(budgetList);
    return budgetList.filter(
      (budget: IBudgetAllocForm) => budget.BudgetType.id == this.budgetType
    );
  }

  // addBudget() {
  //   this.tableAction.emit({
  //     BudgetType: this.budgetType,
  //     mode: 'Add',
  //     row: null,
  //   });
  //   this.updateTable();
  // }

  editBudget(row: IBudgetAllocForm) {
    this.tableAction.emit({
      BudgetType: this.budgetType,
      mode: 'Edit',
      row: row,
    });
  }

  removeSelectedRows() {
    let newData = this.budgetList.budgetList.slice();
    this.rowSelection.selected.forEach((vendor) => {
      let index: number = this.budgetList.budgetList.findIndex(
        (d: IBudgetAllocForm) => d.iBudgetId == vendor.iBudgetId
      );
      newData[index] = {
        ...newData[index],
        isDeleted: true,
      };
    });
    this.budgetList.budgetList = newData;
    this.updateTable();
    this.addItemService.removeBudgetAction();
    this.tableAction.emit({
      mode: 'delete',
      BudgetType: this.budgetType,
      row: null,
    });
    this.rowSelection = new SelectionModel<IBudgetAllocForm>(true, []);
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.rowSelection.clear();
    } else {
      this.dataSource.data.forEach((row) => this.rowSelection.select(row));
    }
  }

  isAllSelected() {
    const numSelected = this.rowSelection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }
  isRowSelected() {
    if (this.rowSelection.selected.length !== 0) return true;
    return false;
  }

  onCheckboxChange($event: any, row: any) {
    $event ? this.rowSelection.toggle(row) : null;
  }

  filterDisplayColumns() {
    switch (this.budgetType) {
      case 'Operating':
        this.displayColumns = this.displayColumns.filter((col) => {
          return (
            col !== 'FundCentre' &&
            col != 'ProjectCode' &&
            col != 'ProjectBudget'
          );
        });
        break;
      case 'Capital':
        this.displayColumns = this.displayColumns.filter((col) => {
          return (
            col !== 'BudgetFrequencyUsage' &&
            col != 'ProjectCode' &&
            col != 'ProjectBudget' &&
            col != 'OrderNo' &&
            col != 'CostCentre'
          );
        });
        break;
      case 'Capital AUC':
        this.displayColumns = this.displayColumns.filter((col) => {
          return (
            col !== 'BudgetFrequencyUsage' &&
            col != 'ProjectCode' &&
            col != 'FundCentre'
          );
        });
        break;
      case 'Project':
        this.displayColumns = this.displayColumns.filter((col) => {
          return (
            col !== 'BudgetFrequencyUsage' &&
            col != 'FundCentre' &&
            col != 'BudgetExpenditureUsage'
          );
        });
        break;
      default:
        this.displayColumns = this.displayColumns.filter((col) => {
          return (
            col !== 'FundCentre' &&
            col != 'ProjectCode' &&
            col != 'ProjectBudget'
          );
        });
    }
  }

  openDialog(record: any) {
    this.dialogRef = this.dialog.open(DialogComponent, {
      // height: '200px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Discard Budget?',
        contentMsg: 'This action cannot be undone.',
        btnNameOne: 'Discard',
        btnNameTwo: 'Cancel',
        click: () => {
          this.editBudget(record);
        },
        clickTwo: () => {
          this.dialogRef.close();
        },
      },
    });
  }

  updateTable() {
    this.currentbudgetList = this.budgetList.budgetList;
    this.dataSource = new MatTableDataSource<IBudgetAllocForm>(
      this.convertToBudgetTable(this.budgetList.budgetList).filter(
        (budget) => !budget.isDeleted
      )
    );
    this.dataSource.paginator = this.paginator;
  }
}

export interface BudgetTableAction {
  BudgetType: string;
  mode: string;
  row: IBudgetAllocForm | null;
}
